// src/components/core/MeetingRouteWrapper.js
import React from 'react';
import { useParams } from 'react-router-dom';
import MeetingRoute from './MeetingRoute';

const MeetingRouteWrapper = () => {
    // This component's only job is to get the 'id' from the URL.
    const { id } = useParams();

    // It then passes this 'id' as a normal prop to the real MeetingRoute component.
    // This bypasses the issue where useParams was not working inside MeetingRoute.
    return <MeetingRoute meetingId={id} />;
};

export default MeetingRouteWrapper;
